/**
 * Bảng lưu giá trị thuế suất (của cả thuế trực tiếp và khấu trừ)
 * NHANH3 12.06.2024
 */
export default {
  NoSelected: -1,
  ZeroPercent: 0,
  OnePercent: 1,
  TwoPercent: 2,
  ThreePercent: 3,
  FivePercent: 5,
  EightPercent: 8,
  TenPercent: 10,
};
